"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetOrThrow = void 0;
const getAssetOrThrow = (assets) => (assetId) => {
    const asset = assets[assetId];
    if (!asset) {
        throw new Error(`Missing asset with id '${assetId}'!`);
    }
    return asset;
};
exports.getAssetOrThrow = getAssetOrThrow;
